import {
  MAP_LAYOUT_MOBILE_MAX_PX,
  getMapOverlayInsets,
} from '@/features/map/constants/mapOverlayLayout';
import { useMediaQuery } from '@/hooks/useMediaQuery';

/**
 * Responsive map overlay insets: desktop matches {@link CONTENT_INSET_LEFT_PX} / right rail;
 * narrow viewports use {@link MAP_EDGE_PADDING_PX} only.
 */
export function useMapOverlayInsets() {
  const isMobile = useMediaQuery(`(max-width: ${MAP_LAYOUT_MOBILE_MAX_PX}px)`);
  return {
    isMobile,
    ...getMapOverlayInsets(isMobile),
  };
}
